<script setup lang="ts">
import SvgTypography from '@files/header/Typography.svg?component';
import { NuxtLink } from '#components';
const { color = 'white' } = defineProps<{
    color: 'white' | 'blue';
}>();

const fontColor = computed(() =>
    color === 'blue' ? 'var(--blue-500)' : color
);
</script>

<template>
    <div class="mrbilit-main-icon-wrapper">
        <NuxtLink
            class="mrbilit-main-icon-wrapper-link"
            to="/"
            aria-label="mrBilit logo"
        >
            <SvgTypography :fill="fontColor" height="50px" width="100px" />
        </NuxtLink>
    </div>
</template>

<style scoped lang="scss">
.mrbilit-main-icon-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
        color: usePalette();
    }

    .mrbilit-main-icon-wrapper-link {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100px;
        &:hover {
            text-decoration: none;
        }

        .icon-container {
            display: flex;
            flex-direction: column;
            align-items: center;
            white-space: nowrap;
        }
    }
}
</style>
